import PopupUploadFiles from './PopupUploadFiles';

export default PopupUploadFiles;